var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form" }, [
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "rprsNmad",
          attrs: {
            id: "rprsNmad",
            value: _vm.data.rprsNmad,
            "label-i18n": "MCOP-01-01-05-06",
            placeholder: "MCOP-01-01-05-06",
            maxlength: 10,
            "err-msg-param": { filed: _vm.$t("MCOP-01-01-05-06"), max: 10 },
            toLowerCase: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "rprsNmad", $event)
            }
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        { staticClass: "item-tit" },
        [
          _vm._v(" " + _vm._s(/*상세 주소*/ _vm.$t("MCOP-01-01-05-07")) + " "),
          _c("required")
        ],
        1
      ),
      _c("div", { staticClass: "item-desc" }, [
        _c("div", { staticClass: "form-text-field" }, [
          _c(
            "div",
            { staticClass: "input-text-field address" },
            [
              _c("input-text", {
                ref: "rprsAddr1",
                attrs: {
                  id: "rprsAddr1",
                  value: _vm.data.rprsAddr1,
                  placeholder: "MCOP-01-01-05-07",
                  maxlength: 66,
                  "err-msg-param": {
                    filed: _vm.$t("MCOP-01-01-05-07"),
                    max: 66
                  },
                  required:
                    _vm.$config.SITECODE_OGCBD +
                    "|" +
                    _vm.$config.SITECODE_OGHCM +
                    "|" +
                    _vm.$config.SITECODE_OGMMR,
                  toLowerCase: ""
                },
                on: {
                  "update:value": function($event) {
                    return _vm.$set(_vm.data, "rprsAddr1", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "input-text-field" },
            [
              _c("input-text", {
                ref: "rprsAddr2",
                attrs: {
                  id: "rprsAddr2",
                  value: _vm.data.rprsAddr2,
                  maxlength: 66,
                  "err-msg-param": {
                    filed: _vm.$t("MCOP-01-01-05-07"),
                    max: 66
                  },
                  toLowerCase: ""
                },
                on: {
                  "update:value": function($event) {
                    return _vm.$set(_vm.data, "rprsAddr2", $event)
                  }
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "rprsAddr3",
          attrs: {
            id: "rprsAddr3",
            value: _vm.data.rprsAddr3,
            "label-i18n": "MCOP-01-01-05-08",
            placeholder: "MCOP-01-01-05-08",
            toLowerCase: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "rprsAddr3", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }